import { render, staticRenderFns } from "./TkRate.vue?vue&type=template&id=6121a058&"
import script from "./TkRate.vue?vue&type=script&lang=js&"
export * from "./TkRate.vue?vue&type=script&lang=js&"
import style0 from "./TkRate.vue?vue&type=style&index=0&id=6121a058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports